export default {
  optOutHint: {
    title: 'Applies to all future versions',
    availability: 'Qmulus no longer opens the highlights after updates. They stay available at any time:',
    versionNumber: 'Version number in the user menu',
    showAgain: 'To show them after updates again, select {location}.',
  },
};
